import UserInfo from './UserInfo';
import UserStats from './UserStats';
import CarManager from './CarManager';
import ActivePosts from './ActivePosts';
import HistoryPosts from './HistoryPosts';
import MyProfilePage from './MyProfilePage';

export {
  UserInfo,
  UserStats,
  CarManager,
  ActivePosts,
  HistoryPosts,
  MyProfilePage
};

export default MyProfilePage;